import { fetchAsObservable } from "fetcher!sofe";
import canopyUrls from "canopy-urls!sofe";
import { pluck } from "rxjs/operators";

export function getPractitioners(clientId) {
  return fetchAsObservable(
    `${canopyUrls.getAPIUrl()}/users?role=TeamMember`
  ).pipe(pluck("users"));
}